<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
    },
});
</script>

<template>
    <ol class="slt-privacy-list-level flex flex-col">
        <li v-for="item in items" :key="item.id">
            <div
                class="slt-privacy-content-wrapper flex flex-col"
                :class="{
                    'gap-[6.09vw] xs:gap-[24px] sm:gap-[3.13vw] lg:gap-[1.59vw] 3xl:gap-[30.5px]':
                        $rt(item.render) === 'h2',
                    'gap-[2.03vw] xs:gap-[8px] sm:gap-[1.04vw] lg:gap-[0.53vw] 3xl:gap-[10.2px]':
                        $rt(item.render) !== 'h2' &&
                        $rt(item.id) !== '4.1' &&
                        $rt(item.id) !== '4.5' &&
                        $rt(item.id) !== '6.1' &&
                        $rt(item.id) !== '6.2',
                    'px-[4.07vw] xs:px-[16px] sm:px-[3.125vw] lg:px-[1.56vw] 3xl:px-[30.5px]':
                        $rt(item.render) === 'h5',
                    'pl-[12.21vw] xs:pl-[48px] sm:pl-[6.25vw] lg:pl-[3.17vw] 3xl:pl-[61px]':
                        $rt(item.render) === 'h6',
                    'gap-[4.07vw] xs:gap-[16px] sm:gap-[2.08vw] lg:gap-[1.06vw] 3xl:gap-[20.3px]':
                        $rt(item.id) === '4.1' ||
                        $rt(item.id) === '4.5' ||
                        $rt(item.id) === '6.1' ||
                        $rt(item.id) === '6.2',
                }"
            >
                <Component
                    v-if="item?.title"
                    :is="$rt(item.render)"
                    :class="{
                        'slt-h3 text-base-black-90': $rt(item.render) === 'h2',
                        'slt-body-1 !leading-[1.7] text-base-black':
                            $rt(item.render) !== 'h2',
                        'pl-[15.27vw] xs:pl-[60px] sm:pl-[7.81vw] lg:pl-[3.97vw] 3xl:pl-[76.2px]':
                            $rt(item.render) === 'p',
                    }"
                >
                    {{ $rt(item.title) }}
                </Component>

                <p
                    v-if="item?.content"
                    class="slt-body-1 !leading-[1.7]"
                    :class="{
                        'text-base-black-80': $rt(item.render) === 'h2',
                        'text-base-black': $rt(item.render) !== 'h2',
                        'pl-[12.21vw] xs:pl-[48px] sm:pl-[6.25vw] lg:pl-[3.17vw] 3xl:pl-[61px]':
                            $rt(item.render) === 'h5',
                        'pl-[15.27vw] xs:pl-[60px] sm:pl-[7.81vw] lg:pl-[3.97vw] 3xl:pl-[76.2px]':
                            $rt(item.render) === 'h6',
                    }"
                >
                    {{ $rt(item.content) }}
                </p>

                <PrivacyPolicyList
                    v-if="item.items && item.items.length > 0"
                    :items="item.items"
                    :class="{
                        'gap-[2.03vw] xs:gap-[8px]': $rt(item.render) !== 'h6',
                        'sm:gap-[1.04vw] lg:gap-[0.53vw] 3xl:gap-[10.2px]':
                            $rt(item.render) === 'h5' || $rt(item.id) === '1',
                        'sm:gap-[3.13vw] lg:gap-[1.59vw] 3xl:gap-[30.5px]':
                            $rt(item.render) === 'h2' && $rt(item.id) !== '1',
                        'mt-[2.03vw] xs:mt-[8px] sm:mt-[1.04vw] lg:mt-[0.53vw] 3xl:mt-[10.2px]':
                            $rt(item.id) === '4.8',
                    }"
                />

                <p
                    v-if="item?.content_2"
                    class="slt-body-1 mt-[2.03vw] pl-[12.21vw] !leading-[1.7] text-base-black xs:mt-[8px] xs:pl-[48px] sm:mt-[1.04vw] sm:pl-[6.25vw] lg:mt-[0.53vw] lg:pl-[3.17vw] 3xl:mt-[10.2px] 3xl:pl-[61px]"
                >
                    {{ $rt(item.content_2) }}
                </p>
            </div>
        </li>
    </ol>
</template>

<style scoped>
.slt-privacy-list-level {
    counter-reset: item-counter;
    list-style-type: none;
}

li {
    counter-increment: item-counter;
}

h2,
h5,
h6 {
    @apply relative;
}

h2 {
    @apply pl-[7.12vw] xs:pl-[28px] sm:pl-[3.65vw] lg:pl-[2.31vw] 3xl:pl-[44.4px];
}

h5 {
    @apply pl-[12.21vw] xs:pl-[48px] sm:pl-[6.25vw] lg:pl-[3.17vw] 3xl:pl-[61px];
}

h6 {
    @apply pl-[15.27vw] xs:pl-[60px] sm:pl-[7.81vw] lg:pl-[3.97vw] 3xl:pl-[76.2px];
}

li > .slt-privacy-content-wrapper h2::before,
li > .slt-privacy-content-wrapper h5::before,
li > .slt-privacy-content-wrapper h6::before {
    content: counters(item-counter, ".") ". ";
    @apply absolute left-0 top-0;
}
</style>
